import { Reference } from '@ninetailed/experience.js';
import { INavigation, INavigationElement } from 'global';

/**
 * Empty reference object used as a fallback when no experiment data is available.
 */
export const EMPTY_REFERENCE: Reference = {
  id: '',
};

/**
 * Creates a proper Reference object from a content entry or returns empty reference.
 * Since Reference only requires an 'id' field, we can safely spread the entry
 * which will include all necessary fields.
 */
export const createReference = (
  entry: INavigation | INavigationElement | null | undefined
): Reference => {
  if (!entry?.sys?.id) {
    return EMPTY_REFERENCE;
  }

  // The entry already has sys.id, so we ensure the id field is set
  // and spread the rest of the entry properties
  return {
    id: entry.sys.id,
    ...entry,
  };
};
